import HasToBeInspectorGuard from 'app/core/guards/HasToBeInspectorGuard';
import HasToBeLoggedInGuard from 'app/core/guards/HasToBeLoggedInGuard';
import React from 'react';
import { Redirect } from 'react-router';
import { RouteConfig } from 'react-router-config';

const PREFIX = '/inspector/';

const inspectorRoutes: Array<RouteConfig> = [
  {
    path: PREFIX + 'dashboard',
    component: React.lazy(
      () => import('../../../main/inspector/dashboard/InspectorDashboard')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },
  {
    path: PREFIX + 'scheduled-inspections',
    component: React.lazy(
      () =>
        import(
          '../../../main/inspector/scheduled-inspections/ScheduledInspections'
        )
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },
  {
    path: PREFIX + 'settings',
    exact: true,
    component: () => <Redirect to={PREFIX + 'settings/general'} />,
  },
  {
    path: PREFIX + 'settings/:sectionId',
    component: React.lazy(
      () => import('../../../main/inspector/settings/InspectorSettingsPage')
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },
  {
    path: PREFIX + 'profile/:sectionId',
    component: React.lazy(
      () =>
        import(
          '../../../main/construction/inspectors/profile/InspectorProfilePage'
        )
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },
  {
    path: PREFIX + 'profile/',
    component: React.lazy(
      () =>
        import(
          '../../../main/construction/inspectors/profile/InspectorProfilePage'
        )
    ),
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },

  // MESSAGES SECTION
  {
    path: '/imi',
    exact: true,
    component: () => <Redirect to={'/inspector/messaging/inbox'} />,
  },
  {
    path: '/imi/:id',
    exact: true,
    component: (props: any) => (
      <Redirect to={`/inspector/messaging/inbox/${props.match.params.id}`} />
    ),
  },
  {
    path: '/inspector/messaging',
    exact: true,
    component: () => <Redirect to={'/inspector/messaging/inbox'} />,
  },
  {
    path: [
      '/inspector/messaging/create-thread/:recipientId',
      '/inspector/messaging/create-thread/:recipientId/:jobId',
    ],
    component: React.lazy(
      () => import('../../../main/inspector/messaging/InspectorCreateThreadPage')
    ),
    exact: true,
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },
  {
    path: [
      '/inspector/messaging/:sectionId',
      '/inspector/messaging/:sectionId/:threadId',
    ],
    component: React.lazy(
      () => import('../../../main/inspector/messaging/InspectorMessagingPage')
    ),
    exact: true,
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },
  {
    path: '/inspector/notifications/:messageId',
    component: React.lazy(
      () =>
        import('../../../main/inspector/messaging/InspectorNotificationLandingPage')
    ),
    exact: true,
    canActivate: [HasToBeLoggedInGuard, HasToBeInspectorGuard],
  },
];

export default inspectorRoutes;
